import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore.js';
import FJClothesChangerStyleListV2 from './FJClothesChangerStyleListV2';
import FJActionClothesChanger from '../../../redux/action/FJActionClothesChanger.js';

function FJClothesChangerStyleListV2Container() {
    useLocalStore();
    const dispatch = useDispatch();
    const tab = useSelector(state => state.clothesChanger?.tab || 0);

    const clothesInfo = useSelector(state => state.clothesChanger?.clothesInfo);

    const handleSelectClothes = useCallback(
        (style, callback) => {
            dispatch(FJActionClothesChanger.setClothesInfoAction(style, callback));
        },
        [dispatch],
    );

    return <FJClothesChangerStyleListV2 value={clothesInfo} onChange={handleSelectClothes} tab={tab} />;
}

export default FJClothesChangerStyleListV2Container;
